import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { ArtistId } from '../models/artist.model'
import { Observable } from 'rxjs'
import { StreamsBySubAccount } from '../models/streams-by-sub-account.model'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class StreamsGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findStreamsGraph(artistId: ArtistId, from: Date, to: Date): Observable<StreamsBySubAccount[]> {
    return this.functions.httpsCallable<
      { artistId: string; from: string; to: string },
      StreamsBySubAccount[]
    >('findStreamsGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
